'use strict';

const Backdrop = require('./backdrop');
const events = require('../services/tracking/blz-event');

const url = blz.domain + '/api/search/autocomplete?q=%QUERY';
const RATE_LIMIT_WAIT = 10;
const $input = $('#autocomplete-input');
const $headerSearch = $('#header-search');
let q = '';
const Bloodhound = window.Bloodhound;

const products = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace('name'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: url,
    rateLimitWait: RATE_LIMIT_WAIT,
    prepare: prepare,
    filter: function (response) {
      q = response.q;
      return response.productResults;
    }
  }
});

var departments = new Bloodhound({
  datumTokenizer: Bloodhound.tokenizers.whitespace('ngram'),
  queryTokenizer: Bloodhound.tokenizers.whitespace,
  remote: {
    url: url,
    rateLimitWait: RATE_LIMIT_WAIT,
    prepare: prepare,
    filter: function (response) {
      var data = [];

      (response.ngramResults || []).forEach(function (item, i) {
        if (i === 0 && shouldApplyDepartmentSegmentationSugestion(item)) {
          item.searchInDepartment = true;
          data.push(allDepartments(item));

          if ((item.departments || []).length > 1) {
            var newItem = $.extend({}, item);
            delete newItem.departments;

            (item.departments || []).forEach(function (dep) {
              if (dep) {
                newItem.name = item.ngramHighlighted + ngramDepartment(dep.name);
                data.push($.extend({ departments: [dep] }, newItem));
              }
            });
          } else {
            const firstDepartment = ((item.departments && item.departments[0]) || {}).name;
            if (firstDepartment) {
              item.name = item.ngramHighlighted + ngramDepartment(firstDepartment);
              item.type = 'term autosuggest';
              data.push(item);
            }
          }
        } else {
          item.name = item.ngramHighlighted;
          item.type = 'term autosuggest';
          data.push(item);
        }
      });

      return data;
    }
  }
});

departments.initialize();
products.initialize();

$headerSearch.on('submit', function (event) {
  if (!$input.val()) {
    event.preventDefault();
  }
});

$input
  .typeahead(
    {
      minLength: 2,
      highlight: true,
      hint: false
    },
    [dataset('departments'), dataset('products')]
  )
  .on('typeahead:select', typeaheadSelect)
  .on('typeahead:active', function () {
    Backdrop.show('tt-backdrop-autocomplete');
  })
  .on('typeahead:close', function () {
    Backdrop.hide('tt-backdrop-autocomplete');
  })
  .on('keypress', function (e) {
    if (e.which === 13 || e.keyCode === 13) {
      $(this).closest('form').submit();
    }
  });

/*
 * Private
 */
function prepare(query, settings) {
  settings.url = settings.url.replace('%QUERY', encodeURIComponent(query));
  return settings;
}

function shouldApplyDepartmentSegmentationSugestion(item) {
  return item.ngramType !== 'sku';
}

function ngramDepartment(department) {
  if (department) {
    return (
      '<span class="autocomplete-department-at"> em </span><span class="autocomplete-department">' +
      department +
      '</span>'
    );
  }
  return '';
}

function allDepartments(item) {
  var obj = $.extend({}, item);
  obj.name = item.ngramHighlighted + ngramDepartment('Todos os Departamentos');
  obj.allDepartments = true;
  return obj;
}

function dataset(type) {
  var display = {
    departments: 'ngram',
    products: 'name'
  };
  var source = {
    departments: departments,
    products: products
  };
  var header = {
    departments: '',
    products: ''
  };
  var footer = {
    departments: '',
    products: '<button type="submit" class="tt-dataset-footer-link">Ver Todos os Produtos</button>'
  };

  return {
    name: type,
    display: display[type],
    source: source[type].ttAdapter(),
    limit: 40,
    templates: {
      header: header[type] || '',
      footer: footer[type] || '',
      suggestion: function (data) {
        if (data.ngram) {
          return renderNgram(data);
        }
        return renderProducts(data);
      }
    }
  };
}

function renderNgram(data) {
  $input.attr('data-src', data._query);
  return '<div class="autocomplete-item">' + data.name + '</div>';
}

function renderProducts(data) {
  if (!data) {
    return '<div></div>';
  }

  var installments = data.priceSpecification && data.priceSpecification.installments;
  var numberOfPayments = '';

  if (installments && installments.numberOfPayments > 1) {
    var monthlyPayment = installments.monthlyPaymentMasked;
    numberOfPayments =
      '<span class="autocomplete-item-installment">' +
      installments.numberOfPayments +
      'x ' +
      monthlyPayment +
      '</span>';
  }

  var price = data.priceSpecification.priceMasked;
  var maxPrice = data.priceSpecification.maxPriceMasked;
  var maxPriceValue =
    data.priceSpecification.discount > 0
      ? '<span class="autocomplete-item-maxprice">' + maxPrice + '</span>'
      : '';

  $input.attr('data-src', data._query);
  var tpl =
    '<div class="autocomplete-item autocomplete-product">\
        <div class="autocomplete-item-image">\
          <img src="' +
    (((data.imageObjects && data.imageObjects[0]) || {}).small || '') +
    '" alt="product image">\
        </div>\
        <div class="autocomplete-item-details">\
          <p class="autocomplete-item-name">' +
    data.name +
    '</p>\
          <p>' +
    maxPriceValue +
    '<span class="autocomplete-item-price' +
    (installments && installments.numberOfPayments <= 1 ? ' autocomplete-item-price-primary' : '') +
    '">' +
    price +
    '</span>' +
    numberOfPayments +
    '</p>\
      </div>\
    </div>';

  return tpl;
}

function addDepartmentToPath(path, item) {
  if (item.departments && item.departments[0].slugName) {
    if (item.searchInDepartment) {
      if (!item.allDepartments) {
        path += '&departamento-categoria=' + item.departments[0].slugName;
        path += '&indexar=falso';
      }
    }
  }
  return path;
}

function typeaheadSelect(event, item) {
  var term = $(event.currentTarget).attr('data-src');
  var path = '';
  var type = 'AUTOCOMPLETE_PRODUCT_CLICK';
  var sku = '';
  var departments = [];

  if (item.departments && item.departments[0].slugName) {
    departments = item.departments;
    path = '/busca/?q=' + $input.typeahead('val');
    path = addDepartmentToPath(path, item);
  }

  if (item.ngram) {
    path = '/busca/?q=' + $input.typeahead('val');
    type = 'AUTOCOMPLETE_NGRAM_CLICK';
    path = addDepartmentToPath(path, item);
  }

  if (item.slugName) {
    sku = item.sku;
    path = '/' + item.slugName + (q && !item.facet ? '?q=' + q : '');
  }

  events.sendAutocompleteItemClick({
    term: term,
    type: type,
    path: path,
    departments: (departments || []).map((department) => department.slugName),
    sku: sku
  });

  location.href = blz.domain + path;
}
